import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
  query FilmToPersonCollection ($filters: [Filter], $limit: Int, $offset: Int, $value: Value, $valueKey: String, $op: String) {
    FilmToPersonCollection: FilmToPeople (filters: $filters, limit: $limit, valueKey: $valueKey, value: $value, offset: $offset, op: $op) {
      ...filmRelationships
      filmID
      personID
      professionID
      id
      Profession {
        ...profession
      }
    }
  }
  ${fragments.filmRelationships}
  ${fragments.companyNames}
  ${fragments.companyNameDetail}
  ${fragments.relationshipTypeDetail}
  ${fragments.profession}
  ${fragments.companyDepartmentDetail}
  ${fragments.companyTypeTree}
  ${fragments.companyType}
`
